import React from "react";
import { 
  HistoryIcon,
} from "components/Icons";
import { reportTypeItems } from '../ResearchNavBar/reportTypes';
import NavBar from "components/Navigations/NavBar/NavBar";
import UIDateRangePicker from "components/form/UIDateRangePicker/UIDateRangePicker.component";
import { Button } from 'components/form/Button';
import DropDown from "components/Dropdown/Dropdown.component";
import { parse, format } from 'date-fns';
import '../ResearchNavBar/ResearchNavBar.component.scss';

export type ShareNavBarProps = {
  longReportType: string;
  startLiteDataDate: string;
  endLiteDataDate: string;
};

const ShareNavBar = ({ longReportType, startLiteDataDate, endLiteDataDate }: ShareNavBarProps) => {
  const lockedDateTypes = ['pestlReport', 'swotReport'];
  const isDateLocked = lockedDateTypes.includes(longReportType);

  const handleSignUpRedirect = () => {
    window.location.href = '/sign-up-senior';
  };

  const handleOptionClick = () => {
    handleSignUpRedirect();
  };

  // Create a modified item list without paths so that onChange handler is used instead of Link navigation
  const shareReportTypeItems = reportTypeItems.map(item => ({
    ...item,
    path: undefined, // Remove path so dropdown uses onChange instead of Link
  }));

  return (
    <NavBar
      theme="dark"
      logo={{ small: true, desktop: true }}
      isDemo={false}
      withoutNavigation={false}
      iconMenuItems={[]}
      leftContent={
        <div className='research-form-options'>
          <DropDown 
            value={longReportType} 
            itemList={shareReportTypeItems} 
            onChange={handleOptionClick} 
            data-testid="report-type-dropdown" 
          />
          <div className={`report-date-picker-wrapper${isDateLocked ? ' is-locked' : ''}`} onClick={handleSignUpRedirect}>
            <UIDateRangePicker 
              onChange={() => {}} 
              className="report-date-range-picker"
              placeholder="Select Date Range" 
              value={[parse(startLiteDataDate, 'yyyy-MM-dd', new Date()), parse(endLiteDataDate, 'yyyy-MM-dd', new Date())]} 
              cleanable={false}
              format="MM/dd/yyyy"
              data-testid="report-date-selector"
              disabled={true}
            />
          </div>
          <div className={`report-date-picker-wrapper mobile${isDateLocked ? ' is-locked' : ''}`} onClick={handleSignUpRedirect}>
            <UIDateRangePicker 
              onChange={() => {}} 
              placeholder="Select Date Range" 
              value={[parse(startLiteDataDate, 'yyyy-MM-dd', new Date()), parse(endLiteDataDate, 'yyyy-MM-dd', new Date())]} 
              cleanable={false}
              className="report-date-range-picker-mobile"
              data-testid="report-date-selector"
              format="MM/dd/yyyy"
              block 
              showOneCalendar
              placement="autoVerticalEnd"
              disabled={true}
            />
          </div>
          <div className="conversation-history-wrapper">
            <Button
              icon={HistoryIcon}
              variant="primary"
              size="medium"
              iconPosition="left"
              onClick={handleSignUpRedirect}
              aria-label="History"
              data-tooltip="Show History"
              data-title="Conversation History"
            >
              History
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default ShareNavBar;
